import React from "react";
import { Helmet } from "react-helmet";

function Unlimitedhostingpolicy() {
  return (
    <>
      <Helmet>
        <title>Unlimited Hosting Policy » ClubHosty</title>
        <link
          rel="canonical"
          href="https://www.clubhosty.com/unlimited-hosting-policy"
        />
      </Helmet>
      <main id="main">
        <section className="breadcrumbs">
          <div className="container">
            <div>
              <h2>Unlimited Hosting Policy</h2>
              <center>
                <p>
                  Unlimited usage policy applies to every hosting service
                  provided by ClubHosty. Shared Hosting VPS Hosting, Reseller
                  Hosting and Dedicated hosting.
                </p>
              </center>
            </div>
          </div>
        </section>

        {/* ======= Services Section =======  */}
        <section id="services" className="services">
          <div className="container">
            <div className="row">
              <div className="col-md-12 section-heading">
                <h3>What Unlimited Means?</h3>
                <p>
                  <i className="fa fa-angle-double-right"></i> Unlimited Disk
                  Space/Bandwidth/Website Plans. This means that we do not set a
                  limit on the amount of bandwidth, websites or disk space you
                  may use in the normal operation of a personal or small
                  business website, provided it complies with this Agreement.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i>
                  However, in the event your service usage or content presents a
                  risk to the stability, performance or uptime of our servers,
                  data storage, networking or other infrastructure, you may be
                  required to upgrade to a VPS, or we may take action to
                  restrict the resources your website is utilizing.
                </p>
              </div>
              <div className="section-heading">
                <h3>Don’t Believe In Myths!</h3>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> ClubHosty runs an
                  automated complex mechanism to give the best security to its
                  customers/subscribers from any kind of abuse.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> ClubHosty
                  Unlimited web hosting offers an unlimited set of resources if
                  you are using Shared Hosting this means multiple users
                  multiple websites are hosted on a single server and it will be
                  fairly unfair if one user exhausts or overuses server
                  resources.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> For ClubHosty
                  every customer is the same, ClubHosty's services are designed
                  to meet the typical needs of small and medium-sized businesses
                  across the globe.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> It is NOT
                  intended to support the sustained demand of large enterprises,
                  or non-typical applications better suited to a VPS or a
                  dedicated server.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> ClubHosty will
                  make every commercially reasonable effort to provide
                  additional resources to Subscribers who are using their
                  website(s) consistent with these Terms, including moving
                  Subscribers to newer and bigger shared servers as necessary.{" "}
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> However, to
                  ensure a consistent and quality experience for all
                  Subscribers, ClubHosty does place automated safeguards to
                  protect against any website growing too quickly and adversely
                  impacting the system until ClubHosty can evaluate said sites
                  resource needs.{" "}
                </p>
              </div>
              <div className="section-heading">
                <h3>Unlimited Hosting Space,excessive SQL Database</h3>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> ClubHosty does
                  not set any specific limits on the amount of disk space a
                  hosting subscriber can use for their website, nor does
                  ClubHosty charge additional fees based on an increased amount
                  of storage used, provided the hosting subscriber's use of
                  storage complies with these Terms.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i>{" "}
                  <b>Please note</b>, however, that the ClubHosty service is
                  designed to host websites. ClubHosty does NOT provide
                  unlimited hosting for online storage, videos, images, audio,
                  games, installers, executable files, backups, or archiving of
                  electronic files, documents, log files, web spider or indexer,
                  IRC, torrent, file sharing, peer-to-peer activities, testing
                  environment etc., and any such prohibited use of the Services
                  will result in the termination of hosting subscriber's
                  account, with or without notice.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> Accounts with an
                  excessive database size (i.e., more than 1 GB) negatively
                  affect the performance of the server. ClubHosty may request
                  that the database size be reduced to ensure proper performance
                  or may disable the Subscriber's account, with or without
                  notice.{" "}
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> Hosting
                  subscriber's can create multiple databases however size of
                  each database should not be more than 1 GB.
                </p>
              </div>
              <div className="section-heading">
                <h3>Unlimited File Transfer</h3>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> ClubHosty does
                  not set any limits on the amount of visitor traffic a website
                  can receive or on the amount of content a hosting subscriber
                  can upload to his/her/its website in a given month, nor does
                  ClubHosty charges additional fees based on increased use of
                  bandwidth, as long as the hosting subscriber's use of the
                  Services complies with these Terms.{" "}
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> In most cases, a
                  hosting subscriber's website will be able to support as much
                  traffic as the hosting subscriber can legitimately acquire.{" "}
                </p>
                <p>
                  <i className="fa fa-angle-double-right"></i> However,
                  ClubHosty reserves the right to limit processor time,
                  bandwidth, processes, or memory in cases where it is necessary
                  to prevent negatively impacting other hosting subscribers.
                </p>
              </div>
              <div className="section-heading">
                <h3>Unacceptable Resource Usage</h3>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> Run cron entries
                  with intervals of less than fifteen (15) minutes.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> Run any MySQL
                  queries longer than thirty (30) seconds.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> Use twenty-five
                  per cent (25%) or more of our system resources for longer than
                  ninety (90) seconds at a time. Activities that could cause
                  this excessive use, include but are not limited to CGI
                  scripts, FTP, PHP, HTTP, etc.
                </p>
                <p>
                  {" "}
                  <i className="fa fa-angle-double-right"></i> The size of each
                  mail box should not exceed 5GB and the combined mailbox size
                  per domain should not exceed 50GB.
                </p>
              </div>
            </div>
          </div>
        </section>
        {/* End Services Section  */}
      </main>
      {/* End #main */}
    </>
  );
}

export default Unlimitedhostingpolicy;
